import moment from "moment";

export const FormattedDate: React.FC<{ timestamp: number }> = ({
  timestamp,
}) => <div>{moment(timestamp).format("ll")}</div>;

export const FormattedTime: React.FC<{ timestamp: number }> = ({
  timestamp,
}) => <div className="sub-text">{moment(timestamp).format("LTS")}</div>;

export const FormattedDateTime: React.FC<{
  timestamp: number;
}> = ({ timestamp }) => {
  return (
    <>
      <FormattedDate timestamp={timestamp} />
      <FormattedTime timestamp={timestamp} />
    </>
  );
};
